import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'app/shared/shared.module';
import { MultiFilesUploadComponent } from './multi-files-upload.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FileUploadTypeIconComponent } from './file-upload-type-icon/file-upload-type-icon.component';
import { TranslocoModule } from '@ngneat/transloco';
import { EnvelopFilesUploadComponent } from './envelop-files-upload.component';
import { EnvelopFilesDetailComponent } from './envelop-files-detail.component';
import { MultiFilesDetailComponent } from './multi-files-detail.component';
import { MultiFilesUploadLargeComponent } from './multi-files-upload-large.component';
import { FlexLayoutModule } from 'ng-flex-layout';

@NgModule({
    declarations: [
        FileUploadTypeIconComponent,
        MultiFilesUploadComponent,
        MultiFilesDetailComponent,
        EnvelopFilesUploadComponent,
        EnvelopFilesDetailComponent,
        MultiFilesUploadLargeComponent
    ],
    imports: [
        MatIconModule,
        MatProgressBarModule,
        HttpClientModule,
        FileUploadModule,
        FlexLayoutModule,
        MatButtonModule,
        TranslocoModule,
        SharedModule
    ],
    exports: [
        FileUploadTypeIconComponent,
        MultiFilesUploadComponent,
        MultiFilesDetailComponent,
        EnvelopFilesUploadComponent,
        EnvelopFilesDetailComponent,
        MultiFilesUploadLargeComponent
    ]
})
export class MultiFilesUploadModule {
}
